// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"bf4fa4cc","676":"b0d5ca64","783":"c9c0da4d"}[chunkId] + ".chunk.css";
};